import React from "react";
import ComponentInfoPopup from "./ComponentInfoPopup";

export default function CanvasCard({
  component,
  setDragged,
  label,
}: {
  component: any;
  setDragged: () => void;
  label?: string;
}) {
  return (
    <div className="col-3">
      <div
        key={component.UUID}
        draggable
        className="border rounded-3 border-purple position-relative d-flex flex-column justify-content-center align-items-center"
        onDragStart={setDragged}
        style={{ aspectRatio: "1/1", cursor: "grab" }}
        title={component.Description}
      >
        <div className="position-absolute top-0 end-0">
          <ComponentInfoPopup component={component} />
        </div>
        <div className="text-center text-sm">{label || component.Label}</div>
      </div>
    </div>
  );
}
